import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const DragIcon = ({ color = '#B5BCBD', size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 16"
    height={size}
    {...props}
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M0 1.6C0 .716.746 0 1.667 0c.92 0 1.666.716 1.666 1.6s-.746 1.6-1.666 1.6S0 2.484 0 1.6m1.667 8c.92 0 1.666-.716 1.666-1.6s-.746-1.6-1.666-1.6S0 7.116 0 8s.746 1.6 1.667 1.6m0 6.4c.92 0 1.666-.716 1.666-1.6s-.746-1.6-1.666-1.6S0 13.516 0 14.4.746 16 1.667 16M8.333 3.2C9.253 3.2 10 2.484 10 1.6S9.254 0 8.333 0c-.92 0-1.666.716-1.666 1.6s.746 1.6 1.666 1.6m0 6.4C9.253 9.6 10 8.884 10 8s-.746-1.6-1.667-1.6c-.92 0-1.666.716-1.666 1.6s.746 1.6 1.666 1.6m0 6.4c.92 0 1.667-.716 1.667-1.6s-.746-1.6-1.667-1.6c-.92 0-1.666.716-1.666 1.6S7.413 16 8.333 16"
    />
  </svg>
);

DragIcon.propTypes = propTypes;

export default DragIcon;
